import { useCallback } from 'react';
import { useRequest } from './useRequest';
import { Event, EventCreate } from '../types/event';

export function useEvent() {
  const listRequest = useRequest<Event[]>();
  const createRequest = useRequest<Event>();
  const updateRequest = useRequest<Event>();
  const deleteRequest = useRequest<void>();

  const fetchEvents = useCallback(() => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/api/eventos`;
    listRequest.execute(url);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createEvent = useCallback(async (data: EventCreate) => {
    await createRequest.execute(`${process.env.REACT_APP_API_BASE_URL}/api/eventos`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateEvent = useCallback(async (id: number, data: Partial<EventCreate>) => {
    await updateRequest.execute(`${process.env.REACT_APP_API_BASE_URL}/api/eventos/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    // Não chamar fetchEvents() automaticamente aqui
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deleteEvent = useCallback(async (id: number) => {
    await deleteRequest.execute(`${process.env.REACT_APP_API_BASE_URL}/api/eventos/${id}`, {
      method: 'DELETE',
    });
    // Não chamar fetchEvents() automaticamente aqui
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    // Estados para listagem
    events: listRequest.data || [],
    listLoading: listRequest.loading,
    listError: listRequest.error,

    // Estados para operações de salvar (create/update)
    saveLoading: createRequest.loading || updateRequest.loading,
    saveError: createRequest.error || updateRequest.error,

    // Estados para operações de deletar
    deleteLoading: deleteRequest.loading,
    deleteError: deleteRequest.error,

    // Funções
    fetchEvents,
    createEvent,
    updateEvent,
    deleteEvent,
  };
}